<template>
    <Head title="Availability Alerts" />
    <div class="@container px-4 md:px-8 lg:py-8">
        <Alerts />
    </div>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import Alerts from '@/components/alerts/alerts.vue';
</script>
